"use client";

import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { SignupFormContainer } from "@faire/retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { SignUpTitle } from "@faire/retailer-visitor-shared/views/SignUp/_components/SignUpTitle";
import {
  FaireDirectSurveyData,
  FaireDirectSurveyForm,
  useSchema,
} from "@faire/retailer-visitor-shared/views/SignUp/brand-relationship-survey/__internal__/FaireDirectSurveyForm";
import { useSignUpRequest } from "@faire/retailer-visitor-shared/views/SignUp/SignUpRequestContext";
import { useSaveRequestAndGoToNextStep } from "@faire/retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/retailer-visitor-shared/views/SignUp/Step";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Formik } from "formik";
import React from "react";

export const FaireDirectSurveyStep: React.FC = () => {
  const { strictLocalize } = useStrictLocalization();
  const schema = useSchema();
  const { faireDirectBrand } = useFaireDirectBrand();
  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.FAIRE_DIRECT_SURVEY
  );
  const [{ faire_direct_signup_attribution }] = useSignUpRequest([
    "faire_direct_signup_attribution",
  ]);

  const onNext = async (values: FaireDirectSurveyData) => {
    saveAndGoToNextStep(values);
  };

  return (
    <SignupFormContainer>
      <SignUpTitle
        title={strictLocalize(
          {
            defaultMessage: "Have you ordered from {brandCompanyName} before?",
            description: {
              img: "https://cdn.faire.com/fastly/fc42519402a2e9488ab3dfd0cb02b39a956f987c1528cd9295a055b1a9e92369.png",
              text: "Title asking if the user has ordered from the brand before",
            },
          },
          {
            brandCompanyName: faireDirectBrand?.name ?? "this brand",
          }
        )}
      />
      <Spacer height="4x" />
      <Formik
        initialValues={{ faire_direct_signup_attribution }}
        onSubmit={onNext}
        validationSchema={schema}
      >
        <FaireDirectSurveyForm />
      </Formik>
    </SignupFormContainer>
  );
};
